import { createApi } from '@/api'
export default {
  projectList: config => createApi(`/medicalproject/pageSearch`, 'post', config), // 项目列表
  projectDetail: config => createApi(`/medicalproject/get`, 'get', config), // 项目详情
  addproject: config => createApi(`/medicalproject/add`, 'post', config), // 项目添加
  deleteproject: config => createApi(`/medicalproject/delete`, 'delete', config), // 项目删除
  updateproject: config => createApi(`/medicalproject/update`, 'post', config) // 项目修改
}



// WEBPACK FOOTER //
// ./src/views/medicalProjectManage/api/index.js